import { Button, Col, Input, message, Pagination, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { BsFilter } from 'react-icons/bs';
import { Link, useHistory } from 'react-router-dom';
import { CampaignSelectLists } from '../../apis/Brand/Campaigns/CampaignSelectLists';
import { GetInfluencers } from '../../apis/Brand/Discovery/GetInfluencers';
import { GetInfluencerLists } from '../../apis/Brand/InfluencerList/GetInfluencerLists';
import CampignIntroComponent from '../../components/Brand/CampignIntroComponent';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import EmptyInfluencerComponent from '../../components/Brand/InfluencerList/EmptyInfluencerComponent';
import InfluencerCardComponent from '../../components/Brand/InfluencerList/InfluencerCardComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { Config } from '../../Config';
import { dispatch, useGlobalState } from '../../store/state';

const { Search } = Input;
const { Option } = Select;
export const BrandDiscoverPage = () => {
  // const history = useHistory();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [create_camp_general] = useGlobalState('create_camp_general');
  const [baseConfig, setBaseConfig] = useState({
    topics: [],
    locations: [],
    type: 'all',
    page: 1,
  });
  const [paramData, setParamData] = useState({
    name: '',
    location: '',
    platform: 'instagram',
    interests: '',
  });
  const [infList, setInfList]= useState({
    list: [],
  });

  const fetchInfluencers = (limit, page) =>{
    const _data = [
      paramData.name && paramData.name.length >= 3 ? `&name=${paramData.name}`:undefined,
      paramData.platform ? `&platform=${paramData.platform}`:undefined,
      paramData.interests ? `&interests=${paramData.interests}`:undefined,
      paramData.location ? `&location=${paramData.location}`:undefined,
    ];

    GetInfluencers(user.accessToken, limit, page, _data).then(({ status, response })=>{
      if (status === 200) {
        setInfList({
          ...response,
        });
      } else {
        console.log('Failed to fetch dicovery data', response);
      }
    });
  };


  // note: getting default select box fields value
  const retriveBaiscFieldSettings = () =>{
    CampaignSelectLists(user.accessToken).then(({ status, response }) =>{
      if (status === 200) {
        // let _set1 = response.topics
        // console.log("set 1",_set1)
        setBaseConfig({
          ...baseConfig,
          topics: response.topics,
          locations: response.locations,
        });
      }
    });
  };

  useEffect(()=>{
    retriveBaiscFieldSettings();
  }, []);

  useEffect(() => {
    fetchInfluencers(20, 1);
  }, [paramData]);

  const onNameSearch = (value) =>{
    setParamData({
      ...paramData,
      name: value,
      location: '',
    });
  };
  const onFilterChange = (value, filter) =>{
    if (filter === 'location') {
      setParamData({
        ...paramData,
        location: value,
      });
    } else if (filter === 'platform') {
      setParamData({
        ...paramData,
        platform: value,
      });
    } else if (filter === 'interests') {
      setParamData({
        ...paramData,
        interests: value,
      });
    } else {}
  };

  const onPagingChange = (page)=>{ // pager changing
    // getCampiagnList(baseConfig.type,page)
    fetchInfluencers(20, page);
    setBaseConfig({
      ...baseConfig,
      page: page,
    });
  };

  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="px-3 pt-0 pb-2 sticky">
        <p className="mb-1"><strong>Discover Influencers</strong></p>
        <div className="row">
          <div className="col-md-3">
            {/* <Input
                        name="influNameSearch"
                        placeholder="Search by name"
                        // minLength="3"
                        // type="search"
                        // value={paramData.name}
                        label="Search by name"
                        prefix={<AiOutlineSearch/>} onChange={onNameSearch}
                       />  */}
            <Select
              style={{ width: 180 }}
              className="common_select"
              name="platform"
              defaultValue={paramData.platform}
              placeholder="Filter by platform"
              onChange={(value) => onFilterChange(value, 'platform')}
            >
              {/* <Option value="">All</Option> */}
              <Option value="youtube">Youtube</Option>
              <Option value="instagram">Instagram</Option>
              <Option value="twitter">Twitter</Option>
            </Select>
            {/* <Search
                            placeholder="Search by name"
                            onSearch={onNameSearch}
                        /> */}
          </div>
          <div className="col-md-9 text-right">
            <span>
              <BsFilter/>
            </span>
            {/* <span className="text-left pl-2">
                            <Search style={{width:180}}
                                className="common_input"
                                placeholder="Search by name"
                                onSearch={onNameSearch}
                            />
                        </span> */}
            <span className="text-left pl-2">
              <Select
                style={{ width: 180 }}
                className="common_select"
                name="location"
                // defaultValue={paramData.location}
                onChange={(value) => onFilterChange(value, 'location')}
                placeholder="Filter by location"
              >
                {/* <Option value="">All</Option>
                                <Option value="Bangalore">Bangalore</Option>
                                <Option value="mumbai">Mumbai</Option>
                                <Option value="delhi">Delhi</Option> */}
                <Option value="">All {Config.country}</Option>
                {
                  baseConfig.locations.map((location)=>{
                    if (location !== `All ${Config.country}`) {
                      return <Option key={location}
                        value={location}>{location}</Option>;
                    }
                  })
                }
              </Select>
            </span>
            <span className="text-left pl-2">
              <Select
                style={{ width: 180 }}
                className="common_select"
                name="interests"
                // defaultValue={paramData.interests}
                placeholder="Filter by interests"
                onChange={(value) => onFilterChange(value, 'interests')}
              >
                <Option value="">All</Option>
                {
                  baseConfig.topics.map((topic)=>(
                    <Option key={topic}
                      value={topic}>{topic}</Option>
                  ))
                }
                {/* <Option value="science">Science</Option> */}
              </Select>
            </span>
          </div>
        </div>
      </BrandTopSubHeaderComponent>
      <div className="d-flex flex-wrap p-2">
        {infList.list && infList.list.length ?
          infList.list.map((influencer) =><InfluencerCardComponent
            key={influencer.id}
            id={influencer.id}
            firstname={influencer.firstname}
            interests={influencer.interests}
            lastname={influencer.lastname}
            profile_pic={influencer?.[`${paramData.platform}_account`]?.influencersocialid?.profilepic}
            followers={influencer?.[`${paramData.platform}_account`]?.influencersocialid?.followingSubscribers}
            postsCount={influencer?.[`${paramData.platform}_account`]?.influencersocialid?.posts}
            username={influencer?.[`${paramData.platform}_account`]?.influencersocialid?.username}
            allowAddList
            allowProfileBtn
            platform={paramData.platform}/> ):
          <EmptyInfluencerComponent>No influencers found</EmptyInfluencerComponent>
        }
      </div>
      {
        infList.list.length?
          (<Pagination
            onChange={onPagingChange}
            // defaultCurrent={1}
            current={baseConfig.page}
            total={infList.listCount}
            defaultPageSize={infList.limit}
          />) :
          null
      }
    </BrandBaseLayoutComponent>
  );
};
